export const sourcePromoCodeHandler = (
  baseApplyURL,
  storageKey = 'source_code'
) => {

  if (typeof window === 'undefined') {
    return baseApplyURL;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const passedPromoCode = urlParams.get('promo_code');
  const passedSourceCode = urlParams.get('source_code');

  const TRACKING_PARAMS = [
    'fbclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];

  // Store tracking params from URL → sessionStorage
  TRACKING_PARAMS.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      sessionStorage.setItem(param, value);
    }
});

  if (!passedPromoCode && !passedSourceCode) {
    return baseApplyURL; // return as-is if no params
  }

  const sourceCode = passedSourceCode || localStorage.getItem(storageKey);

  if (passedSourceCode) {
    localStorage.setItem(storageKey, passedSourceCode);
  }

   const resolvedURL = baseApplyURL?.startsWith('/')
    ? new URL(baseApplyURL, window.location.origin + window.location.pathname)
    : new URL(baseApplyURL);

  if (sourceCode) {
    resolvedURL.searchParams.set('source_code', sourceCode);
  }

  // Append tracking params from sessionStorage
  TRACKING_PARAMS.forEach((param) => {
    const value = sessionStorage.getItem(param);
    if (value) {
      resolvedURL.searchParams.set(param, value);
    }
  });

  // Return relative or absolute based on original input
  return baseApplyURL.startsWith('/')
    ? resolvedURL.pathname + resolvedURL.search
    : resolvedURL.toString();
};
